import React from 'react';
export const AutoRefreshContext = React.createContext(true);

export const AutoRefreshProvider = ({children}) => {
    const [autoRefresh, setAutoRefresh] = React.useState(true);
    return <AutoRefreshContext.Provider value={{autoRefresh, setAutoRefresh}}>
        {children}
    </AutoRefreshContext.Provider>
}
